var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlexContainer',_vm._b({class:_vm.scrollClasses,style:(_vm.scrollStyles)},'FlexContainer',_vm.flexProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }